import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getTimeTrialStore = (state: RootState) => state.timeTrialStore;
const getTimeTrialList = createSelector(getTimeTrialStore, ({ timeTrialList }) => timeTrialList);

export { getTimeTrialList };
